import { render, staticRenderFns } from "./DialogLoaderComponent.vue?vue&type=template&id=380f95f7&"
import script from "./DialogLoaderComponent.vue?vue&type=script&lang=js&"
export * from "./DialogLoaderComponent.vue?vue&type=script&lang=js&"
import style0 from "./DialogLoaderComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports